import { useAcl } from 'vue-simple-acl';
import { Rule } from '@/acl/rules';

const EXCLUDED_ENVS = ['production', 'hiber-web-oman'];
const ENV_TITLE = import.meta.env.VITE_APP_TITLE || '';
const DEFAULT_TITLE = import.meta.env.MODE === 'hiber-web-oman' ? 'Hiber Web Oman' : 'Hiber Cloud';

export function usePageTitle() {
  const { can } = useAcl();

  function setPageTitle(organizationName?: string) {
    let title = DEFAULT_TITLE;

    const isLocal = window.location.hostname === 'localhost';
    const isExcludedEnv = EXCLUDED_ENVS.includes(import.meta.env.MODE);
    const shouldShowPrefix = isLocal || !isExcludedEnv;

    const prefix = shouldShowPrefix && ENV_TITLE ? `${ENV_TITLE} ` : '';

    if (can(Rule.CUSTOMER_SUPPORT) && organizationName) {
      title = `${prefix}${organizationName} - ${DEFAULT_TITLE}`;
    } else {
      title = prefix ? `${prefix}- ${DEFAULT_TITLE}` : DEFAULT_TITLE;
    }

    document.title = title;
  }

  return { setPageTitle };
}
